var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from "moment";
import { createKey } from "../../../../../Shared/utils/createKey";
/**
 * Adds a recipe assignment to a meal on the selectedDay.
 * This function does not dispatch a store update, it only returns the updated meals.
 * This allows us to reuse this logic for the Recipe module and the Customization modal.
 *
 * @param enableAssignRecipes
 * @param enableAddMeals
 * @param enableRemoveMeals
 * @param cartMeals
 * @param program
 * @param deliveryDays
 * @param selectedDay
 * @param recipe
 * @param programMealId
 * @param assignmentId
 * @param createNewAssignment
 * @param setAssignmentId
 * @returns
 */
export const incrementRecipe_V2 = ({ enableAssignRecipes, enableAddMeals, enableRemoveMeals, clonedMeals, program, deliveryDays, selectedDay, recipe, programMealId, assignmentId, createNewAssignment, shouldSetAssignmentId, setAssignmentId, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e;
    const recipeName = recipe.RecipeName;
    const recipeShortName = recipe.RecipeShortName;
    const recipeId = recipe.RecipeId;
    let mealPrice = 0;
    //For Klaviyo event
    let mealName = "";
    //For Customization modal
    let disableAddButton = false;
    let currentAssignmentQuantity = 0;
    // Needed to apply default customizations
    let currentRecipeAssignment = undefined;
    const recipeAssignment = recipe.Assignments.find((assignment) => assignment.ProgramMealId === programMealId && moment(assignment.Date).isSame(moment(selectedDay)));
    const mealExists = clonedMeals
        ? clonedMeals.some((meal) => moment(meal.MealDate).isSame(moment(selectedDay)) && meal.ProgramMealId === programMealId)
        : false;
    if (mealExists) {
        const meals = clonedMeals === null || clonedMeals === void 0 ? void 0 : clonedMeals.map((meal) => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (moment(meal.MealDate).isSame(moment(selectedDay)) && meal.ProgramMealId === programMealId) {
                mealPrice = meal.Price;
                mealName = meal.ProgramMealName;
                let assignment = meal.RecipeAssignments &&
                    meal.RecipeAssignments.find((a) => (a.RecipeId === recipeId && a.ProgramMealId === programMealId && !assignmentId) ||
                        a.AssignmentId === assignmentId);
                const totalAssignmentQuantity = (_b = (_a = meal.RecipeAssignments) === null || _a === void 0 ? void 0 : _a.reduce((total, assignment) => total + assignment.Quantity, 0)) !== null && _b !== void 0 ? _b : 0;
                // un-remove a meal only if we're going to exceed the meal quantity by adding a new assignment
                if (enableRemoveMeals &&
                    meal.NumRemovedAssignments &&
                    meal.NumRemovedAssignments > 0 &&
                    totalAssignmentQuantity >= meal.Quantity) {
                    meal.NumRemovedAssignments -= 1;
                }
                if (!enableAssignRecipes) {
                    meal.Quantity += 1;
                }
                else if (enableAddMeals && enableAssignRecipes && totalAssignmentQuantity === meal.Quantity) {
                    meal.Quantity += 1;
                }
                if (!!assignment && !createNewAssignment) {
                    currentRecipeAssignment = assignment;
                    assignment.Quantity += 1;
                    currentAssignmentQuantity = assignment.Quantity;
                    // If the user increments an assignment then it is no longer an automatic selection
                    currentRecipeAssignment.IsAutomaticSelection = false;
                    //Recalculate total to check if meal qty has been met for the customize modal
                    const updatedAssignmentQuantity = (_d = (_c = meal.RecipeAssignments) === null || _c === void 0 ? void 0 : _c.reduce((total, assignment) => total + assignment.Quantity, 0)) !== null && _d !== void 0 ? _d : 0;
                    //If we cant add meals and the meal quantity is met, disable the add button.
                    if (!enableAddMeals && updatedAssignmentQuantity === meal.Quantity) {
                        disableAddButton = true;
                    }
                }
                else {
                    if (!meal.RecipeAssignments) {
                        meal.RecipeAssignments = [];
                    }
                    const recipePrice = (_e = recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.RecipeAssignmentPrice) !== null && _e !== void 0 ? _e : 0;
                    const newAssignmentId = createKey();
                    if (shouldSetAssignmentId) {
                        // Update the assignmentId for customization
                        setAssignmentId(newAssignmentId);
                    }
                    const newAssignment = {
                        RecipeId: recipeId,
                        RecipeName: recipeName,
                        RecipeShortName: recipeShortName,
                        ProgramMealId: programMealId,
                        Date: moment(selectedDay),
                        Quantity: 1,
                        SelectedIngredientOptions: [],
                        RecipePrice: recipePrice,
                        IsAutomaticSelection: false,
                        CompatibilityType: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.CompatibilityType,
                        AutomaticReplacements: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.AutomaticReplacements,
                        RecipeAssignmentPrice: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.RecipeAssignmentPrice,
                        Skips: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.Skips,
                        AssignmentId: newAssignmentId,
                    };
                    meal.RecipeAssignments.push(newAssignment);
                    const updatedAssignmentQuantity = (_g = (_f = meal.RecipeAssignments) === null || _f === void 0 ? void 0 : _f.reduce((total, assignment) => total + assignment.Quantity, 0)) !== null && _g !== void 0 ? _g : 0;
                    //If we cant add meals and the meal quantity is met, disable the add button.
                    if (!enableAddMeals && updatedAssignmentQuantity === meal.Quantity) {
                        disableAddButton = true;
                    }
                    currentRecipeAssignment = newAssignment;
                    currentAssignmentQuantity = 1;
                }
            }
            return meal;
        });
        return {
            meals,
            currentRecipeAssignment,
            recipeName,
            mealPrice,
            mealName,
            mealDate: moment(selectedDay),
            disableAddButton,
            currentAssignmentQuantity,
        };
    }
    else {
        const programMeal = program.ProgramMeals.find((pm) => pm.ProgramMealId === programMealId);
        const deliveryDate = (_a = deliveryDays.find((dd) => moment(dd.MealDateString).isSame(moment(selectedDay)))) === null || _a === void 0 ? void 0 : _a.ShipDateString;
        const recipePrice = (_b = recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.RecipeAssignmentPrice) !== null && _b !== void 0 ? _b : 0;
        mealPrice = programMeal === null || programMeal === void 0 ? void 0 : programMeal.Price;
        mealName = programMeal === null || programMeal === void 0 ? void 0 : programMeal.ProgramMealName;
        const newAssignmentId = createKey();
        if (shouldSetAssignmentId) {
            // Update the assignmentId for customization
            setAssignmentId(newAssignmentId);
        }
        const newAssignment = {
            Quantity: 1,
            RecipeId: recipeId,
            RecipeName: recipeName,
            RecipeShortName: recipeShortName,
            Date: moment(selectedDay),
            ProgramMealId: programMealId,
            SelectedIngredientOptions: (_c = recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.SelectedIngredientOptions) !== null && _c !== void 0 ? _c : [],
            RecipePrice: recipePrice,
            IsAutomaticSelection: false,
            CompatibilityType: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.CompatibilityType,
            AutomaticReplacements: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.AutomaticReplacements,
            RecipeAssignmentPrice: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.RecipeAssignmentPrice,
            Skips: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.Skips,
            AssignmentId: newAssignmentId,
        };
        const meals = [
            ...clonedMeals,
            {
                MealDate: moment(selectedDay),
                OriginalMealDate: moment(selectedDay),
                DeliveryDate: moment(deliveryDate),
                ProgramMealId: programMealId,
                ProgramMealName: (_d = programMeal === null || programMeal === void 0 ? void 0 : programMeal.MealName) !== null && _d !== void 0 ? _d : "",
                Price: (_e = programMeal === null || programMeal === void 0 ? void 0 : programMeal.Price) !== null && _e !== void 0 ? _e : 0,
                Quantity: 1,
                RecipeAssignments: [newAssignment],
                NumRemovedAssignments: 0,
                MealTypeId: programMeal === null || programMeal === void 0 ? void 0 : programMeal.MealTypeId,
                IsSkipped: false,
            },
        ];
        currentRecipeAssignment = newAssignment;
        currentAssignmentQuantity = 1;
        return {
            meals,
            currentRecipeAssignment,
            recipeName,
            mealPrice,
            mealName,
            mealDate: moment(selectedDay),
            disableAddButton,
            currentAssignmentQuantity,
        };
    }
});
